var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AiTaggingRepository } from '../repositories/ai-tagging-repository.interface';
import _ from 'lodash';
import { DEFAULT_NODE_SUMMARY } from '../constants';
const MIN_PARSING_TIME = 200;
let NodeParsingServiceImpl = class NodeParsingServiceImpl {
    constructor(_aiTaggingRepository) {
        this._aiTaggingRepository = _aiTaggingRepository;
        this._initData = null;
        this._pendingNodes = [];
        this._currentParsingIndex = 0;
        this._skipParsingSign = false;
        this._startTimestamp = 0;
        this._timer = null;
        this._formatTreeToList = (nodes) => {
            const result = [];
            const format = (nodes, parentId) => {
                nodes.forEach(node => {
                    if (parentId) {
                        node.parentId = parentId;
                    }
                    result.push(node);
                    if (node.children) {
                        format(node.children, node.id);
                    }
                });
            };
            format(nodes);
            return result;
        };
    }
    _onStartParsing(node) {
        if (this._initData) {
            this._initData.onStartParsing(node);
        }
    }
    _onFinishParsing(nodeId, data, percent) {
        if (this._initData) {
            this._initData.onFinishParsing(nodeId, data, percent);
        }
    }
    _onError(node, error) {
        if (this._initData) {
            this._initData.onError(node, error);
        }
    }
    _onAllParsingFinished() {
        if (this._initData) {
            this._initData.onAllParsingFinished();
        }
    }
    get _parsingPercent() {
        return _.floor((this._currentParsingIndex / this._pendingNodes.length) * 100);
    }
    getParentIdsByNodeId(nodeId) {
        const parentIds = [nodeId];
        const self = this;
        function findParentNode(id) {
            const node = self._pendingNodes.find(node => node.id === id);
            if (node) {
                parentIds.unshift(node.id);
                if (node.parentId) {
                    findParentNode(node.parentId);
                }
            }
        }
        findParentNode(nodeId);
        return _.uniq(parentIds);
    }
    _parsingNode() {
        /**
         * 页面切换时，停止解析
         * */
        if (this._skipParsingSign)
            return;
        const parsingNode = this._getParsingNode();
        if (parsingNode) {
            this._onStartParsing(parsingNode);
            let parentIds = [];
            if (parsingNode.parentId) {
                parentIds = this.getParentIdsByNodeId(parsingNode.parentId);
            }
            this._startTimestamp = new Date().getTime();
            this._aiTaggingRepository.parsingNode({
                folderId: this._initData.folderId,
                fieldId: this._initData.fieldId,
                nodeId: parsingNode.id,
                parentIds,
            }).then((res) => {
                this._onFinishParsing(parsingNode.id, res, this._parsingPercent);
            }).catch((error) => {
                this._onFinishParsing(parsingNode.id, DEFAULT_NODE_SUMMARY, this._parsingPercent);
                this._onError(parsingNode, error);
            }).finally(() => {
                const now = Date.now();
                const reqTime = now - this._startTimestamp;
                const delay = Math.max(0, MIN_PARSING_TIME - reqTime);
                /**
                 * 已经有缓存的数据接口请求速度较快，导致页面扫描效果不佳，
                 * 当接口请求时常小于500ms时，
                 * 增加时间补偿， 达到500ms在解析下一条数据
                 */
                clearTimeout(this._timer);
                this._timer = setTimeout(() => {
                    this._parsingNode();
                }, delay);
            });
        }
        else {
            this._onAllParsingFinished();
        }
    }
    _getParsingNode() {
        if (this._currentParsingIndex <= this._pendingNodes.length - 1) {
            return this._pendingNodes[this._currentParsingIndex++];
        }
    }
    _skipParsing() {
        this._skipParsingSign = true;
    }
    startParsing(params) {
        this._skipParsingSign = false;
        this._currentParsingIndex = 0;
        this._initData = params;
        this._pendingNodes = this._formatTreeToList(params.nodes);
        this._parsingNode();
        // 返回跳过解析的方法
        return this._skipParsing.bind(this);
    }
};
NodeParsingServiceImpl = __decorate([
    injectable(),
    __param(0, inject(AiTaggingRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof AiTaggingRepository !== "undefined" && AiTaggingRepository) === "function" ? _a : Object])
], NodeParsingServiceImpl);
export { NodeParsingServiceImpl };
